export default {
  List: {
    Caption: "Nhà cung cấp",
    AddButton: "Thêm mới",
    SearchPlaceHolder: "Tìm kiếm nhà cung cấp",
  },
  Detail: {
    AddTitle: "Thêm mới nhà cung cấp",
    EditTitle: "Sửa nhà cung cấp",
    DuplicateTitle: "Nhân bản nhà cung cấp",
    GeneralTabCaption: "Thông tin chung",
    ContactTabCaption: "Thông tin liên hệ",
    AccountObjectCode: "Mã nhà cung cấp",
    AccountObjectName: "Tên nhà cung cấp",
    AccountObjectGroupListName: "Nhóm nhà cung cấp",
    Address: "Địa chỉ",
    TaxCode: "Mã số thuế",
    Website: "Website",
    BankAccount: "TK ngân hàng",
    Tel: "ĐT cơ quan",
    BankName: "Mở tại",
    Email: "Email",
    Description: "Ghi chú",
    Phone: "Điện thoại",
    Prefix: "Xưng hô",
    ContactHomePhone: "ĐT nhà riêng",
    ContactName: "Họ và tên",
    ContactMobile: "ĐT di động",
    ContactTitle: "Chức danh",
    ContactTel: "ĐT cơ quan",
    ContactEmail: "Email",
    ContactAddress: "Địa chỉ",
    IdentificationNumber: "Số CMND/TCC",
    IssueDate: "Ngày cấp",
    IssueBy: "Nơi cấp",
  },
  AccountObjectGroup: {
    Name: "Tên nhóm",
    Code: "Mã nhóm",
    Description: "Ghi chú",
  },
  AccountObjectGroupDetail: {
    Add: "Thêm Nhóm nhà cung cấp",
    Edit: "Sửa Nhóm nhà cung cấp",
    AccountObjectGroupName: "Tên",
    AccountObjectGroupCode: "Mã",
    Description: "Ghi chú",
  },
  Search: {
    Title: "Nhà cung cấp",
  },
};
